import React, { useContext } from 'react'
import { Flex, Button, Text } from 'rebass'
// @ts-ignore
import { useUneeqState, UneeqContext, stripSsml } from 'uneeq-react-core'
import { sendMessage } from '../../socket'
import styles from './styles'
import { ReactComponent as ExclamationIcon } from '../MayaErrors/exclamation.svg'

const MayaStatement = () => {
  const { dispatch, restartSession } = useContext(UneeqContext)
  const { statement } = useUneeqState()

  if (!statement) return null

  const restart = () => {
    dispatch({ type: 'mayaMessage', payload: { type: 'restartSession' } })
    restartSession()
    sendMessage({ type: 'begin' })
  }

  return (
    <Flex sx={styles.container}>
      <Flex sx={styles.warning}>
        <Flex>
          <Flex sx={styles.icon}>
            <ExclamationIcon />
          </Flex>
          <Text sx={styles.heading}>Error</Text>
        </Flex>
        <Text sx={styles.message}>{stripSsml(statement.message)}</Text>
        {statement.showRestart && (
          <Flex sx={{ flexDirection: 'column' }}>
            <Flex sx={styles.divider} />
            <Button sx={styles.closeButton} variant="primary" onClick={restart}>
              Restart
            </Button>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default MayaStatement
